// extracted by mini-css-extract-plugin
module.exports = {"loginModal":"loginModal-module--loginModal--lYBow","divider":"loginModal-module--divider--3uEqp"};